import { render, staticRenderFns } from "./user_level_edit.vue?vue&type=template&id=4000a796&scoped=true"
import script from "./user_level_edit.vue?vue&type=script&lang=js"
export * from "./user_level_edit.vue?vue&type=script&lang=js"
import style0 from "./user_level_edit.vue?vue&type=style&index=0&id=4000a796&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000a796",
  null
  
)

export default component.exports